import React, { useEffect, useState } from "react";
import Store from "./store";
import { MessageResultState } from "../../types/general-types";
import Button from "../Button";
import { FaRedo } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";

type CaptchaProps = {
  onChange: (data: { token: string; code: string }) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  length?: number;
};

const Captcha: React.FC<CaptchaProps> = ({
  onChange,
  label = "",
  placeholder = "Security Code",
  className = "",
  length = 6,
}) => {
  const store = new Store();
  const { t } = useTranslation();

  const [captchaImage, setCaptchaImage] = useState<string>();
  const [captchaToken, setCaptchaToken] = useState("");
  const [input, setInput] = useState("");

  const loadCaptcha = async () => {
    store.GetECaptcha(length).then((response) => {
      if (response.state === MessageResultState.SUCCESS) {
        setCaptchaImage(response.result.image);
        setCaptchaToken(response.result.token);
        setInput("");
        onChange({ token: response.result.token, code: "" });
      }
    });
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInput(value);
    onChange({ token: captchaToken, code: value });
  };

  return (
    <>
      {captchaImage ? (
        <div className={`captcha-container ${className}`}>
          <div className="row" style={{ alignItems: "center" }}>
            <div className="col-5">
              {label && <label>{label}</label>}

              <input
                type="text"
                className="form-control"
                value={input}
                onChange={handleInputChange}
                placeholder={t(placeholder)}
              />
            </div>
            <div className="col-7">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <img src={captchaImage} alt="e-captcha" style={{}} />

                <Button
                  className="btn btn-primary align-items-center"
                  onClick={loadCaptcha}
                  icon={<FaRedo />}
                  tooltipText={t("Refresh")}
                  type="button"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Captcha;
